import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { chain, chainAsync } from './chain.js';

var flatten = function flatten(array) {
  var _ref;

  return (_ref = []).concat.apply(_ref, _toConsumableArray(array));
};

var parsers = {};
var asyncParsers = {};
var nativeParsers = {
  '@csl/object': function cslObject(input) {
    return [input];
  },
  '@csl/list+object': function cslListObject(input) {
    return input;
  },
  '@else/list+object': function elseListObject(input) {
    return flatten(input.map(chain));
  },
  '@invalid': function invalid() {
    throw new Error('This format is not supported or recognized');
  }
};
var nativeAsyncParsers = {
  '@else/list+object': function () {
    var _elseListObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = flatten;
              _context.next = 3;
              return Promise.all(input.map(chainAsync));

            case 3:
              _context.t1 = _context.sent;
              return _context.abrupt("return", (0, _context.t0)(_context.t1));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function elseListObject(_x) {
      return _elseListObject.apply(this, arguments);
    }

    return elseListObject;
  }()
};
export var data = function data(input, type) {
  if (typeof parsers[type] === 'function') {
    return parsers[type](input);
  } else if (typeof nativeParsers[type] === 'function') {
    return nativeParsers[type](input);
  } else {
    throw new TypeError("No synchronous parser found for ".concat(type));
  }
};
export var dataAsync = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input, type) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(typeof asyncParsers[type] === 'function')) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", asyncParsers[type](input));

          case 4:
            if (!(typeof nativeAsyncParsers[type] === 'function')) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return", nativeAsyncParsers[type](input));

          case 8:
            if (!hasDataParser(type, false)) {
              _context2.next = 12;
              break;
            }

            return _context2.abrupt("return", data(input, type));

          case 12:
            throw new TypeError("No parser found for ".concat(type));

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function dataAsync(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var addDataParser = function addDataParser(format, _ref3) {
  var parser = _ref3.parser,
      async = _ref3.async;

  if (async) {
    asyncParsers[format] = parser;
  } else {
    parsers[format] = parser;
  }
};
export var hasDataParser = function hasDataParser(type, async) {
  return async ? asyncParsers[type] || nativeAsyncParsers[type] : parsers[type] || nativeParsers[type];
};
export var removeDataParser = function removeDataParser(type, async) {
  delete (async ? asyncParsers : parsers)[type];
};
export var listDataParser = function listDataParser(async) {
  return Object.keys(async ? asyncParsers : parsers);
};